"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatters = getFormatters;
const getDateFormatter_js_1 = require("./internal/formatters/getDateFormatter.js");
const getTimeFormatter_js_1 = require("./internal/formatters/getTimeFormatter.js");
const getDateTimeFormatter_js_1 = require("./internal/formatters/getDateTimeFormatter.js");
const getRelativeFormatter_js_1 = require("./internal/formatters/getRelativeFormatter.js");
const getHourFormatter_js_1 = require("./internal/formatters/getHourFormatter.js");
const getDateStringFormatter_js_1 = require("./internal/formatters/getDateStringFormatter.js");
function getFormatters(intlFormatters, translate) {
    return {
        ...intlFormatters,
        formatDate: (0, getDateFormatter_js_1.getDateFormatter)(intlFormatters),
        formatDateString: (0, getDateStringFormatter_js_1.getDateStringFormatter)(intlFormatters),
        formatTime: (0, getTimeFormatter_js_1.getTimeFormatter)(intlFormatters),
        formatDateTime: (0, getDateTimeFormatter_js_1.getDateTimeFormatter)(intlFormatters),
        formatRelative: (0, getRelativeFormatter_js_1.getRelativeFormatter)(intlFormatters, translate),
        formatHour: (0, getHourFormatter_js_1.getHourFormatter)(intlFormatters),
    };
}
//# sourceMappingURL=formatters.js.map